// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { CompletionStatusType, AssessmentModule, Option } from '../../../../types/Model';
import CheckBox from '../../../CheckBox';
import Prologue from './Prologue';
import Epilogue from './Epilogue';
import { S } from './styles';
interface AssessmentModuleProps {
  data: AssessmentModule;
  status?: CompletionStatusType;
  triggerProgress: (newScore:number) => void;
  handleNextModule: () => void;
}

const AssessmentContent: React.FC<AssessmentModuleProps> = ({
  triggerProgress,
  handleNextModule,
  data
}):JSX.Element => {
  const {
    name,
    assessmentId
  } = data;
  const questions = useMemo(() => data.questions.sort(() => Math.random() - 0.5), [data]);
  const [isAssessmentRunning, setIsAssessmentRunning] = useState<boolean>(false);
  const [currentQuestion, setCurrentQuestion] = useState<number>(0);
  const [score, setScore] = useState<number>(0);
  const [isAnswered, setIsAnswered] = useState(false);
  const [currentSelected, setCurrentSelected] = useState<Option[]>([]);
  const container = useRef<HTMLDivElement>(null);
  const totalQuestions = questions.length;

  // useEffect(() => {
  // console.log({
  //   questions,
  //   currentQuestion,
  //   totalQuestions,
  //   isAssessmentRunning,
  //   answer: currentSelected })
  // },
  // [questions, currentQuestion, totalQuestions, isAssessmentRunning, currentSelected])

  useEffect(() => {
    if (container.current) {
      container.current.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }, [currentQuestion])

  useEffect(() => {
    handleRestartAssessment();
  }, [assessmentId])

  function handleStartAssessment() {
    setIsAssessmentRunning(true);
    setIsAnswered(false)
  }

  function handleRestartAssessment() {
    setIsAssessmentRunning(false);
    setCurrentQuestion(0);
    setCurrentSelected([]);
    setScore(0);
  }

  function handleFinishAssessment() {
    setIsAssessmentRunning(false);
    triggerProgress(Math.round(score/totalQuestions * 100));
  }

  function handleNextQuestion() {
    setCurrentQuestion(currentQuestion + 1);
    setCurrentSelected([]);
    setIsAnswered(false)
  }

  function handleSelect(option: Option) {
    if (!isAnswered) {
      if (questions[currentQuestion].single) {
        setCurrentSelected([option]);
      } else if (currentSelected.indexOf(option) === -1) {
        setCurrentSelected([...currentSelected, option]);
      } else {
        setCurrentSelected([...currentSelected].filter(a => a !== option));
      }
    }
  }

  function handleSubmitAnswer() {
    if (container.current) {
      container.current.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
    setIsAnswered(true)
    if (questions[currentQuestion].single) {
      if (currentSelected[0].isAnswer) {
        setScore(score+1);
      }
    } else {
      const correctOptions = questions[currentQuestion].options.filter(o => o.isAnswer);
      if (!correctOptions.some((o) => currentSelected.indexOf(o) === -1)
        && !currentSelected.some((o) => correctOptions.indexOf(o) === -1)
      ) {
        setScore(score+1)
      }
    }
  }

  function renderCorrectLabel(label: string) {
    return <S.CorrectLabel>{label}</S.CorrectLabel>
  }

  function renderWrongLabel(label: string) {
    return <S.WrongLabel>{label}</S.WrongLabel>
  }

  function renderDefaultLabel(label: string) {
    return <S.DefaultLabel>{label}</S.DefaultLabel>
  }

  function renderExplanation() {
    if (!isAnswered) {
      return null;
    }

    if (questions[currentQuestion].single) {
      return currentSelected[0].isAnswer ? (
        <S.ExplanationContainer isCorrect={true}>
          <S.ExplanationTitle isCorrect={true}><FormattedMessage id="F031" /></S.ExplanationTitle>
          <S.ExplanationText>{questions[currentQuestion].explanation}</S.ExplanationText>
        </S.ExplanationContainer>
      ) : (
        <S.ExplanationContainer isCorrect={false}>
          <S.ExplanationTitle isCorrect={false}><FormattedMessage id="F033" /></S.ExplanationTitle>
          <S.ExplanationText>{questions[currentQuestion].explanation}</S.ExplanationText>
        </S.ExplanationContainer>
      )
    } else {
      const correctOptions = questions[currentQuestion].options.filter(o => o.isAnswer);
      return correctOptions.some((o) => currentSelected.indexOf(o) === -1)
      || currentSelected.some((o) => correctOptions.indexOf(o) === -1) ? (
          <S.ExplanationContainer isCorrect={false}>
            <S.ExplanationTitle isCorrect={false}><FormattedMessage id="F033" /></S.ExplanationTitle>
            <S.ExplanationText>{questions[currentQuestion].explanation}</S.ExplanationText>
          </S.ExplanationContainer>
        ) : (
          <S.ExplanationContainer isCorrect={true}>
            <S.ExplanationTitle isCorrect={true}><FormattedMessage id="F031" /></S.ExplanationTitle>
            <S.ExplanationText>{questions[currentQuestion].explanation}</S.ExplanationText>
          </S.ExplanationContainer>
        )
    }
  }

  if (!isAssessmentRunning) {
    if (currentQuestion > 0) {
      return <Epilogue
        name={name}
        handleRestartAssessment={handleRestartAssessment}
        handleNextModule={handleNextModule}
        correctQuestions={score}
        totalQuestions={totalQuestions}
      />
    } else {
      return <Prologue
        name={name}
        handleStartAssessment={handleStartAssessment}
        handleNextModule={handleNextModule}
      />
    }
  } else {
    return (
      <S.Container>
        <S.Content ref={container}>
          {renderExplanation()}
          <S.Question>{questions[currentQuestion].question}</S.Question>
          <S.InputWrapper>
            {
              questions[currentQuestion].options.map((option, index) => {
                if (questions[currentQuestion].single) {
                  return (
                    <S.RadioInput
                      key={index}
                      onClick={() => handleSelect(option)}
                      checked={currentSelected[0] === option}
                      id={option.option + '_' + index}
                      label={option.option}
                      isAnswered={isAnswered}
                      isAnswer={option.isAnswer}
                    />
                  )
                } else {
                  return (
                    <CheckBox
                      key={index}
                      value={index}
                      checked={currentSelected.indexOf(option) !== -1}
                      onChange={() => handleSelect(option)}
                      disabled={isAnswered && !option.isAnswer}
                    >
                      {
                        isAnswered ?
                          option.isAnswer ?
                            renderCorrectLabel(option.option)
                            : renderWrongLabel(option.option)
                          : renderDefaultLabel(option.option)
                      }
                    </CheckBox>
                  )
                }
              }
              )
            }
          </S.InputWrapper>
        </S.Content>
        <S.Footer>
          <S.Guide>
            <FormattedMessage
              id="F029"
              values={{
                currentQuestion: currentQuestion + 1,
                totalQuestions
              }}
            />
          </S.Guide>
          {
            isAnswered ?
              currentQuestion + 1 === totalQuestions ?
                <S.Button onClick={handleFinishAssessment}><FormattedMessage id="F034" /></S.Button>
                :
                <S.Button onClick={handleNextQuestion}><FormattedMessage id="F032" /></S.Button>
              :
              <S.Button
                disabled={currentSelected.length === 0}
                onClick={handleSubmitAnswer}
              ><FormattedMessage id="F030" /></S.Button>
          }
        </S.Footer>
      </S.Container>
    )
  }

}

export { AssessmentContent as default };

